import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedInvoiceResultRequestDto } from 'src/app/models/backend';
import { ICreateInvoicesDto, IInvoicesDto } from 'src/app/models/backend/invoices';
import { PagedResultDto } from 'src/app/shared/components/paged-listing-component-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoicesService {
  id: any;
  // readonly url=environment.apiUrl+'Countries/';
  readonly url = environment.apiUrl+'Invoices/'

  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
    .set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', `Bearer ${this.Token}`);

  constructor(private http: HttpClient) { }
  getInvoices(payload:IPagedInvoiceResultRequestDto)
  {
    return this.http.post<PagedResultDto<IInvoicesDto>>(this.url+'GetInvoices',payload,{headers:this.headers});
  }
  createInvoicePayment(CreateInvoiceDto:ICreateInvoicesDto){
    return this.http.post<ICreateInvoicesDto>(this.url+'CreateInvoicePayment',CreateInvoiceDto,{headers:this.headers})   
  }
  printInvoice(id){
    return this.http.post(this.url+'ExportInvoice?invoiceNumber='+id,null,{headers:this.headers});
  }
}
